// extracted by mini-css-extract-plugin
export default {"container":"download_container__M8lH0","icon":"download_icon__ZNL2u"};